// @flow
import * as React from 'react';
import { DateInput as Source, DateInputProps } from '@coverright/ui/inputs';
import { TickIcon } from './tick-icon';
import { Calendar as CalendarIcon } from 'lucide-react';


export const DateInput = (props: DateInputProps) => (
  <Source calendarIcon={CalendarIcon} {...props} tickIcon={<TickIcon />} />
)
